"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExperienceGraphEdge = void 0;
var ExperienceGraphEdge;
(function (ExperienceGraphEdge) {
    ExperienceGraphEdge["ROLE_ADJACENCY"] = "RoleAdjacency";
    ExperienceGraphEdge["BUILDER_ROLE_SKILLS"] = "BuilderRoleSkills";
    ExperienceGraphEdge["BUILDER_SKILLS"] = "BuilderSkills";
    ExperienceGraphEdge["BUILDER_ROLES"] = "BuilderRoles";
    ExperienceGraphEdge["TEAMMATE_SPECIALIZATIONS"] = "TeammateSpecializations";
})(ExperienceGraphEdge = exports.ExperienceGraphEdge || (exports.ExperienceGraphEdge = {}));
//# sourceMappingURL=ExperienceGraphEdge.js.map